import React from 'react';
import { useReveal } from '../lib/useReveal';
const BONUSES = [{
  num: '01',
  title: 'Reiki en 7 Días',
  desc: 'Tu guía de inicio rápido. Primera semana completamente estructurada para empezar a practicar desde el día 1 sin perderte en el camino.'
}, {
  num: '02',
  title: 'Mapa Completo de los Chakras',
  desc: 'El sistema de chakras explicado de forma práctica y visual. Cómo diagnosticar, equilibrar y trabajar cada chakra en tus sesiones reales.'
}, {
  num: '03',
  title: 'Manual Anti Dudas Reiki',
  desc: 'Las preguntas que todo practicante se hace y nadie responde claramente. Tu guía de consulta rápida para cuando no sabés qué hacer.'
}, {
  num: '04',
  title: 'Protocolo Reiki de 10 Minutos',
  desc: 'Sesiones cortas y efectivas para cuando el tiempo es limitado. Protocolos específicos de 10 minutos con resultados reales.'
}, {
  num: '05',
  title: 'Reiki de Bolsillo',
  desc: 'La guía compacta que siempre llevás con vos. Afirmaciones, frases y todo lo esencial del Reiki para consulta rápida en cualquier momento.'
}, {
  num: '06',
  title: 'Diario de Práctica y Progreso Reiki',
  desc: 'Tu acompañamiento diario. Registro guiado de cada sesión para que veas tu evolución en tiempo real y mantengas la constancia.'
}];
export function BonusesSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#FAFAF8] py-20 md:py-32 px-5 sm:px-6 border-t border-[#EAE6E1]" data-id="element-42">
      <div className="container mx-auto max-w-5xl" data-id="element-43">
        <div ref={ref1} className={`reveal text-center mb-16 md:mb-24 ${vis1 ? 'is-visible' : ''}`} data-id="element-44">
          <h2 className="text-3xl md:text-5xl font-bold text-[#1E2330] mb-6" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-45">
            Además recibís GRATIS
          </h2>
          <p className="text-xl md:text-2xl text-[#4A5568] font-medium" data-id="element-46">
            Valor real:{' '}
            <span className="line-through text-[#A0AEC0]" data-id="element-47">$53.000</span>
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10" data-id="element-48">
          {BONUSES.map((bonus, idx) => <div key={idx} className="bg-white rounded-3xl p-10 md:p-12 shadow-[0_15px_40px_rgba(0,0,0,0.04)] border border-[#EAE6E1] flex flex-col h-full transition-all duration-300 hover:shadow-[0_20px_50px_rgba(0,0,0,0.08)] hover:-translate-y-1" data-id="element-49">
              <div className="flex items-center justify-between mb-8" data-id="element-50">
                <span className="text-[#D4AF37] font-bold text-4xl" style={{
              fontFamily: "'Playfair Display', serif"
            }} data-id="element-51">
                  {bonus.num}
                </span>
                <span className="bg-[#FAFAF8] text-[#1E2330] text-xs font-bold px-4 py-2 rounded-full uppercase tracking-widest border border-[#EAE6E1]" data-id="element-52">
                  Bono
                </span>
              </div>
              <h3 className="text-2xl font-bold text-[#1E2330] mb-4 leading-snug" data-id="element-53">
                {bonus.title}
              </h3>
              <p className="text-[#4A5568] text-base leading-relaxed flex-grow" data-id="element-54">
                {bonus.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}